
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources01Off as ObiSources01OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-01-off.js';
 
 
 

 
 export const ObiSources01Off = createComponent({
   react: React,
   tagName: 'obi-sources-01-off',
   elementClass: ObiSources01OffElement,
   events: {
     
   }
  });
 
 